/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Watermarks of the scheduled applications snapshot. The snapshot is reconciled on a fixed platform-wide schedule.
 */
export type IdentityProviderConnectionApplicationsSync = {
  /**
   * ISO 8601 timestamp of the last syncApplications call; a request newer than synced_at runs on the next coordinator pass.
   */
  requestedAt?: Date | undefined;
  /**
   * ISO 8601 timestamp when the last completed run started. Omitted until the first run.
   */
  syncedAt?: Date | undefined;
};

/** @internal */
export const IdentityProviderConnectionApplicationsSync$inboundSchema:
  z.ZodMiniType<IdentityProviderConnectionApplicationsSync, unknown> = z.pipe(
    z.object({
      requested_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
      synced_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "requested_at": "requestedAt",
        "synced_at": "syncedAt",
      });
    }),
  );

export function identityProviderConnectionApplicationsSyncFromJSON(
  jsonString: string,
): SafeParseResult<
  IdentityProviderConnectionApplicationsSync,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      IdentityProviderConnectionApplicationsSync$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'IdentityProviderConnectionApplicationsSync' from JSON`,
  );
}
